var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('section',{staticClass:"app"},[_c('div',{staticClass:"app-error"},[_c('div',{staticClass:"app-error-title"},[_c('span',[_vm._v(_vm._s(_vm.$t('apps.app.error_app')))])]),_vm._v(" "),_c('div',{staticClass:"app-error-button"},[_c('ui-link',{staticClass:"btn",attrs:{"to":{
                        name: 'apps',
                    }}},[_c('span',[_vm._v(_vm._s(_vm.$t('apps.go_catalog')))])])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }